import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { searchUrl, apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
import axios from "axios";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import Table from "react-bootstrap/Table";
import TableHeader from "components/Table/TableHeader";
import PechaKuchaChannelsLocationsTableRow from "components/ManagePechaKucha/PechaKuchaChannelsLocationsTableRow";
import UserContext from "store/UserContext";
import AddEditChannelModal from "components/Modals/AddEditChannelModal";

import { asyncContainer, Typeahead } from "react-bootstrap-typeahead";
const AsyncTypeahead = asyncContainer(Typeahead);

function PechaKuchaChannels(props) {
  const context = UserContext;
  let temp_pagination_from = 0;
  const pagination_limit = 100;

  const [channel_table_loading, setChannelTableLoading] = useState(true); // 1
  const [channels, setChannels] = useState(); // 2
  const [pagination_from, setPaginationFrom] = useState(0); // 3
  const [total_search_results, setTotalSearchResults] = useState(0); // 4
  const [message, setMessage] = useState(); // 5
  const [error_message, setErrorMessage] = useState(); // 6
  const [isFiltering, setIsFiltering] = useState(false); // 7
  const [modalShowing, setModalShowing] = useState(false); // 8
  // const [activeChannels, setActiveChannels] = useState();
  // const [inactiveChannels, setInactiveChannels] = useState();
  const [editableChannel, setEditableChannel] = useState(); // 9

  const channels_table_header_display = {
    Name: "",
    "Channel Page": "",
    Created: "",
    "": "",
  };
  let workspace_base_url = "";

  useEffect(() => {
    (async () => {
      await getChannelsFromApi();
    })();
  }, []);

  async function getChannelsFromApi() {
    let query_filter = "all";
    try {
      let channels_search_response = await axios.get(
        `${searchUrl}sitesearch?sort_by=entity_name&sort_order=desc&entity_type=channels&q=${encodeURIComponent(
          query_filter
        )}&all_statuses=true&from=${temp_pagination_from}&limit=${pagination_limit}`,
        myHeaders_Auth_With_Cache_Control
      );
      let search_query_results =
        channels_search_response.data &&
        channels_search_response.data.search_query_results
          ? channels_search_response.data.search_query_results
          : [];
      setChannels(search_query_results.map((data) => data.entity_info));

      if (
        channels_search_response.data &&
        channels_search_response.data.additional_information &&
        "total_search_results" in
          channels_search_response.data.additional_information
      ) {
        setTotalSearchResults(
          channels_search_response.data.additional_information
            .total_search_results
        );
      }
    } catch (err) {
      console.error("Search Error!", err);
    }
    setChannelTableLoading(false);
  }

  async function paginationHandler(e) {
    let new_pagination_from = 0;
    if (e.direction === "forward") {
      new_pagination_from = pagination_from + pagination_limit;
      setPaginationFrom(new_pagination_from);
      temp_pagination_from = new_pagination_from;
      // can't go past the end
      if (new_pagination_from >= channels) {
        new_pagination_from = pagination_from;
      }
    } else if (e.direction === "backward") {
      new_pagination_from = pagination_from - pagination_limit;
      setPaginationFrom(new_pagination_from);
      temp_pagination_from = new_pagination_from;
      // can't go below 0
      if (new_pagination_from < 0) {
        new_pagination_from = 0;
      }
    }
    setChannelTableLoading(true);
    await getChannelsFromApi();
  }

  async function clearSearch() {
    setChannelTableLoading(true);
    ref.current.clear();
    await getChannelsFromApi();
  }

  async function resetFilter(event) {
    if (event.key === "Enter") {
      if (event.target.value === "") {
        setChannelTableLoading(true);
        setPaginationFrom(0);
        temp_pagination_from = 0;
        await getChannelsFromApi();
      }
    }
  }

  //TypeAhead stuff
  const ref = useRef();
  const filterBy = () => true;

  async function filteringChannels(query_filter) {
    setIsFiltering(true);
    setChannelTableLoading(true);
    let channels_search_response = await axios.get(
      `${searchUrl}sitesearch?sort_by=entity_name&sort_order=desc&entity_type=channels&q=${encodeURIComponent(
        query_filter
      )}&from=${temp_pagination_from}&limit=${pagination_limit}`,
      myHeaders_Auth_With_Cache_Control
    );

    let search_query_results =
      channels_search_response.data &&
      channels_search_response.data.search_query_results
        ? channels_search_response.data.search_query_results
        : [];
    setChannels(search_query_results.map((data) => data.entity_info));
    setTotalSearchResults(null);
    setChannelTableLoading(false);
    setIsFiltering(false);
  }

  async function selectedFilteredChannel(selectedChannel) {
    setPaginationFrom(0);
    temp_pagination_from = 0;
    setChannels(selectedChannel);
    setChannelTableLoading(false);
  }

  const handleShow = (channelInfo) => {
    setModalShowing(true);
    setEditableChannel(channelInfo);
  };

  async function handleClose() {
    setModalShowing(false);
    setEditableChannel();
    getChannelsFromApi();
  }

  return (
    <div className="presenters-info pkListContainer eventCreation">
      <Row>
        <Col lg={12}>
          <br />
          <h1>PechaKucha Channels</h1>
          <hr />
          <br />
          <Button variant="pkprimary" onClick={handleShow} className="mb-2">
            Add Channel
          </Button>
          <Row>
            <Col>
              <div className="search-nav border">
                <i className="fa fa-search nav-search"></i>
                <AsyncTypeahead
                  id="ChannelTypeAhead"
                  // labelKey={(channel) =>
                  //   `${channel.entity_name} - ${channel.friendly_url}`
                  // }
                  labelKey="friendly_url"
                  isLoading={isFiltering}
                  filterBy={filterBy}
                  placeholder="Search/Filter Channels"
                  ref={ref}
                  minLength={0}
                  onChange={selectedFilteredChannel}
                  onSearch={filteringChannels}
                  options={channels}
                  onKeyDown={resetFilter}
                />
              </div>
            </Col>
            <Col>
              <button
                style={{ marginTop: "0px" }}
                className="btn-global btn-green Form_Btn_Pad font-normal marTop5 table-buttons"
                onClick={clearSearch}
              >
                Clear Search and Refresh
              </button>
            </Col>
          </Row>

          {channel_table_loading && (
            <div className="createEventSpinner">
              <ActivityIndicator theme="spinner" />
            </div>
          )}
          {!channel_table_loading && (
            <React.Fragment>
              {message && (
                <span style={{ color: "green", paddingTop: "10px" }}>
                  <br />
                  {message}
                </span>
              )}
              {error_message && (
                <span style={{ color: "red", paddingTop: "10px" }}>
                  <br />
                  {error_message}
                </span>
              )}
              <p className="related-name" style={{ float: "right" }}>
                {pagination_from > 0 && (
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      paginationHandler({ direction: "backward" });
                    }}
                  >
                    Previous
                  </span>
                )}
                {pagination_from + pagination_limit < total_search_results &&
                  pagination_from + pagination_limit < 1000 && (
                    <span
                      style={{ marginLeft: "20px", cursor: "pointer" }}
                      onClick={() => {
                        paginationHandler({ direction: "forward" });
                      }}
                    >
                      Next
                    </span>
                  )}
              </p>
              <div className="table-boby">
                <Table variant={context.theme} responsive={true}>
                  <tbody>
                    {/* Pending section header*/}
                    <TableHeader
                      headerType="Channels"
                      tableHeader={channels_table_header_display}
                      listLength={channels.length}
                    />
                    {/* Pending section Body*/}

                    {channels.map((item, i) => {
                      return (
                        <PechaKuchaChannelsLocationsTableRow
                          key={i}
                          data={item}
                          workspace_base_url={workspace_base_url}
                          handleShow={handleShow}
                        />
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </React.Fragment>
          )}
        </Col>
      </Row>
      {editableChannel ? (
        <AddEditChannelModal
          show={modalShowing}
          channelInfo={editableChannel}
          handleClose={() => handleClose()}
        />
      ) : null}
    </div>
  );
}

export default PechaKuchaChannels;
